import { Box, Grid, Typography, useTheme } from '@mui/material'
import { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'

const Stepper = ({ step, onboardingSteps }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Grid>
      <ColStack spacing={12}>
        <Typography variant='eyebrow'>
          {t('common.step')} {onboardingSteps[step].number} →{' '}
          {t(`onboarding.${onboardingSteps[step].name}.title`)}
        </Typography>
        <RowStack width={400} spacing={6} justifyContent='space-between'>
          {onboardingSteps.map((item, index) => (
            <Box
              key={`progress-bar-${index}`}
              width='100%'
              backgroundColor={
                index <= step ? theme.palette.primary.main : colors.MutedTeal300
              }
              sx={{ height: 4, borderRadius: 4 }}
            />
          ))}
        </RowStack>
      </ColStack>
    </Grid>
  )
}

export default Stepper
